import { render, staticRenderFns } from "./TheSideBar.vue?vue&type=template&id=71297223&scoped=true"
import script from "./TheSideBar.vue?vue&type=script&lang=js"
export * from "./TheSideBar.vue?vue&type=script&lang=js"
import style0 from "./TheSideBar.vue?vue&type=style&index=0&id=71297223&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71297223",
  null
  
)

export default component.exports